import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCompanies, saveBatchCompanies } from '../../api/companies';
import type { Company } from '../../types/Company';
import { t } from '../../i18n/t';

const columnDefs: ColDef<Company>[] = [
  {
    field: 'companyId',
    headerName: t('companies.columns.companyId'),
    width: 110,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<Company>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'companyHebName', headerName: t('companies.columns.companyHebName'), flex: 1, editable: true },
  { field: 'companyEngName', headerName: t('companies.columns.companyEngName'), flex: 1, editable: true },
  { field: 'crn', headerName: t('companies.columns.crn'), width: 140, editable: true, cellDataType: 'number' },
];

const newRowDefaults = (): Partial<Company> => ({ companyId: 0, companyHebName: '', companyEngName: null, crn: null });

export function CompaniesPage() {
  return (
    <LopCrudPage<Company>
      resourceCode="companies"
      titleKey="companies.pageTitle"
      idField="companyId"
      getRows={getCompanies}
      saveBatch={(added, modified, deletedIds) => saveBatchCompanies(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
